import { useBackend } from "../../services";

export const useGrantPatreonAccess = () => {
  const { post } = useBackend();
  return async (code: string) => {
    return await post("patreon/token", { code: code });
  };
};
